const KEY = "hc_recent";
const MAX = 12;

export function recordView(p) {
  try {
    const cur = JSON.parse(localStorage.getItem(KEY)) || [];
    const item = {
      id: p.id, slug: p.slug, name: p.name,
      price: p.price, sale_price: p.sale_price, stock: p.stock,
      image: p.images?.[0] || "", category_name: p.category_name || "",
    };
    const next = [item, ...cur.filter((x) => x.id !== p.id)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* storage unavailable */ }
}

export function getRecent() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}

export function removeRecent(id) {
  try {
    const next = getRecent().filter((x) => x.id !== id);
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch { return []; }
}
